export default [
    {
        path:'/login', component: () => import('@/views/security')
    }
]